export default __webpack_public_path__ + "static/media/preventivi.84b03036.png";